import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Page } from "src/app/util/page";
import { Restock } from "../restock";
import { RestockSearchResult } from "../restock-search-result";
import { RestockService } from "../restock.service";

@Component({
  templateUrl: './restock-search.component.html',
  styleUrls: ['./restock-search.component.css']
})
export class RestockSearchComponent {
  public restocks!: Page<RestockSearchResult>

  constructor(restockService: RestockService, private router: Router) {
    restockService.search().subscribe(restocks => this.restocks = restocks);
  }

  public openRestock(restock: RestockSearchResult) {
    this.router.navigateByUrl("/purchase/restock/" + restock.id);
  }
}